import React, { useEffect, useState } from 'react';
import DataTable from 'components/shared/DataTable';
import { BWSelectionModal } from 'components/shared/BWModal';
import { getList } from 'services/promotion-offers.service';
import { useFormContext } from 'react-hook-form';
import { defaultPaging } from 'utils/helpers';
import PromotionOffersFilter from 'pages/PromotionOffers/components/table/PromotionOffersFilter';
import './PromotionPOOffersModal.scss';

const PromotionPOOffersModal = ({ open, columns, onClose, onSelectOffers }) => {
  const methods = useFormContext();
  const [params, setParams] = useState({
    is_active: 1,
    include_gifts: 1,
    page: 1,
    itemsPerPage: 10,
  });
  const [promotionOfferData, setPromotionOfferData] = useState(defaultPaging);
  const [loading, setLoading] = useState(false);
  const [selectedOffers, setSelectedOffers] = useState(
    () => methods.getValues('promotion_offer_apply_list') || [],
  );
  const { items, itemsPerPage, page, totalItems, totalPages } = promotionOfferData;

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    getList(params)
      .then((data) => {
        if (isMounted) setPromotionOfferData(data || defaultPaging);
      })
      .catch(() => {
        if (isMounted) setPromotionOfferData(defaultPaging);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [params]);

  const handleSubmitFilter = (values) => {
    setParams((current) => ({ ...current, ...values, page: 1 }));
  };

  const handleConfirm = () => {
    if (onSelectOffers) {
      onSelectOffers(selectedOffers);
    } else {
      methods.setValue('promotion_offer_apply_list', selectedOffers, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
    onClose();
  };

  return (
    <BWSelectionModal
      open={open}
      title='Danh sách ưu đãi khuyến mại'
      description='Chọn một hoặc nhiều ưu đãi để áp dụng cho chương trình khuyến mại.'
      selectedCount={selectedOffers.length}
      confirmLabel='Xác nhận'
      closeLabel='Đóng'
      onConfirm={handleConfirm}
      onClose={onClose}
      modalClassName='bw_promotion_offer_picker_modal'
      bodyClassName='bw_promotion_offer_picker_body'
      testId='promotion-offer-picker-modal'>
      <div className='bw_promotion_offer_picker_filters'>
        <PromotionOffersFilter
          onClear={() => {
            setParams({
              is_active: 1,
              include_gifts: 1,
              page: 1,
              itemsPerPage: 10,
            });
          }}
          onChange={handleSubmitFilter}
        />
      </div>

      <div className='bw_promotion_offer_picker_table'>
        <DataTable
          plain
          variant='standard'
          loading={loading}
          hiddenDeleteClick
          hiddenActionRow
          fieldCheck='promotion_offer_id'
          defaultDataSelect={selectedOffers}
          columns={columns}
          data={items || []}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          page={page}
          totalItems={totalItems}
          onChangeSelect={setSelectedOffers}
          onChangePage={(nextPage) => {
            setParams((current) => ({
              ...current,
              page: nextPage,
            }));
          }}
        />
      </div>
    </BWSelectionModal>
  );
};

export default PromotionPOOffersModal;
